module.exports = __webpack_public_path__ + "img/ServiceCenterCn.b5047cc4.png";